import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Returns_ds_blind_shipping_container_return_tasks_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shippingContainerId: number, taskStatusIds?: number[] }): 
  Promise<{ result: { Id?: number, ActualInventoryAmount?: number, ActualPackagedAmount?: number, ExpectedPackagedAmount?: number, ExpectedTargetLocationId?: number, Result?: string, StatusId?: number, WarehouseId?: number, Material?: { Id?: number, LookupCode?: string }, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string }, Lot?: { Id?: number, LookupCode?: string, Status?: { Id?: number, Name?: string } }, ActualPackagedPack?: { Id?: number, ShortName?: string }, Order?: { Id?: number, LookupCode?: string }, Project?: { Id?: number, LookupCode?: string }, SerialNumber?: { Id?: number, LookupCode?: string }, ActualTargetLicensePlate?: { Id?: number, LookupCode?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shippingContainerId)) {
      missingRequiredInParams.push('\'shippingContainerId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_blind_shipping_container_return_tasks_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { shippingContainerId: number, taskStatusIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualInventoryAmount?: number, ActualPackagedAmount?: number, ExpectedPackagedAmount?: number, ExpectedTargetLocationId?: number, Result?: string, StatusId?: number, WarehouseId?: number, Material?: { Id?: number, LookupCode?: string }, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string }, Lot?: { Id?: number, LookupCode?: string, Status?: { Id?: number, Name?: string } }, ActualPackagedPack?: { Id?: number, ShortName?: string }, Order?: { Id?: number, LookupCode?: string }, Project?: { Id?: number, LookupCode?: string }, SerialNumber?: { Id?: number, LookupCode?: string }, ActualTargetLicensePlate?: { Id?: number, LookupCode?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shippingContainerId)) {
      missingRequiredInParams.push('\'shippingContainerId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_blind_shipping_container_return_tasks_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { shippingContainerId: number, taskStatusIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualInventoryAmount?: number, ActualPackagedAmount?: number, ExpectedPackagedAmount?: number, ExpectedTargetLocationId?: number, Result?: string, StatusId?: number, WarehouseId?: number, Material?: { Id?: number, LookupCode?: string }, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string }, Lot?: { Id?: number, LookupCode?: string, Status?: { Id?: number, Name?: string } }, ActualPackagedPack?: { Id?: number, ShortName?: string }, Order?: { Id?: number, LookupCode?: string }, Project?: { Id?: number, LookupCode?: string }, SerialNumber?: { Id?: number, LookupCode?: string }, ActualTargetLicensePlate?: { Id?: number, LookupCode?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shippingContainerId)) {
      missingRequiredInParams.push('\'shippingContainerId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_blind_shipping_container_return_tasks_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shippingContainerId: number, taskStatusIds?: number[]    }) {
        if(isNil(inParams.shippingContainerId)) {
          return true; 
        }
      return false;
    }
}
